import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setIsLoading } from "../store/slices/session/sessionSlice";

const useDefaults = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIsLoading(false));
  }, [dispatch]);
};

export default useDefaults;
